import InternationalPhoneNumberInput from '~/javascripts/components/InternationalPhoneNumberInput';
import store from '~/javascripts/store';

function PhoneNumberField({ customInputWrapperClassName = '', hideOptionalPlaceholder = false, isRequired = false }) {
  if (store.donateForm.managementMode) return null;

  return (
    <div className='phone-number-fields'>
      <InternationalPhoneNumberInput
        customInputWrapperClassName={customInputWrapperClassName}
        defaultCountry={store.donateForm.country}
        defaultNumber={store.donateForm.phoneNumber.hiddenFieldValue}
        disableHiddenField={true}
        hideOptionalPlaceholder={hideOptionalPlaceholder}
        isRequired={isRequired}
        onChange={(phoneNumber) =>
          (store.donateForm.phoneNumber.hiddenFieldValue = phoneNumber)
        }
      />
    </div>
  );
}

export default PhoneNumberField;
